import React, { useEffect, useState } from 'react';
import { checkUserId, delay, getThemeMode, local, truncateString } from '../../../../../utils/helper';
import { useSelector } from 'react-redux';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import ChatFullScreenButton from '../../../../chatFullScreenButton';

function Home({
  title,
  subtitle,
  widgetBlocks,
  setShowInnerPage,
  setActiveWidget,
  setActiveWidgetBlock,
}) {
  const { widgetConfig, recentMessage, isSessionAvailable, isChatFullScreen } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
    recentMessage: state.messages.recentMessage,
    isSessionAvailable: state.messages.isSessionAvailable,
    isChatFullScreen: state.messages.isChatFullScreen
  }));
  
  const [isBgLight, setIsBgLight] = useState(false);

  useEffect(() => {
    if(widgetConfig?.config?.widgetId) {
      setIsBgLight(getThemeMode(widgetConfig?.widgetConfig?.lookAndFeel?.backgroundColor))
    }
  }, [widgetConfig])
  
  const handleCardClick = (item) => {
    setShowInnerPage(true);
    setActiveWidgetBlock(item);
  }

  const handleStartNewChat = () => {
    if(navigator?.onLine){
      setActiveWidget(widgetConfig?.widgetConfig?.preChatSurvey?.display ? 'Message' : 'ChatBot');
    } else {
      alert("Please check your internet connection and try again")
    }
  }

  const handleRecentMessage = () => {
    // const event = new CustomEvent("restoreChatMessages", {
    //   detail: "Button was clicked!",
    // });
    // window.dispatchEvent(event);
    // delay(500);
    setActiveWidget('ChatBot');
  }

  return (
    <>
      <div className='rcw-home-1'>
        <div className='rcw-home-2'>
          <div className='rcw-home-3'>
            <div className='rcw-main'>
              <ChatFullScreenButton isBgLight={isBgLight} />
              <div className='rcw-home-subheader'>
                <div className='rcw-logo'>
                  <img src={widgetConfig?.widgetConfig?.lookAndFeel?.backgroundLogo} />
                </div>
                <div className='rcw-home-title' style={{
                  color: isBgLight ? '#000000' : '#ffffff'
                }}>
                  <p className='main-title'>{truncateString(title, isChatFullScreen ? 60 : 18)}</p>
                  <p className='main-subtitle'>{truncateString(subtitle, isChatFullScreen ? 60 : 18)}</p>
                </div>
              </div>
              <div className='rcw-home-card-container'>
                {isSessionAvailable && 
                  <div 
                    className='rcw-home-card' 
                    onClick={() => handleRecentMessage()}
                    // onClick={() => 
                    //   (recentMessage?.content?.data[0]?.message?.content?.text || recentMessage?.content?.text) ? 
                    //     handleRecentMessage() : 
                    //       ''
                    // }
                    // style={{
                    //   cursor: (recentMessage?.content?.data[0]?.message?.content?.text || recentMessage?.content?.text) ? '' : 'not-allowed'
                    // }}
                  >
                    <div className="rcw-home-card-title">
                      Recent message
                    </div>
                    <div className="rcw-home-card-desc">
                      <span className="intercom-messenger-card-list-item-text-subtitle-secondary-text">
                        {truncateString((recentMessage?.content?.data ? recentMessage?.content?.data[0]?.message?.content?.text : recentMessage?.content?.text) ?? '', 45)}
                      </span>
                    </div>
                    <div className='rcw-home-right-arrow'>
                      <MdOutlineKeyboardArrowRight cursor={'pointer'} size={30} color={'#000000'} />
                    </div>
                  </div>
                }
                {widgetBlocks?.map(item => 
                  <div className='rcw-home-card' onClick={() => handleCardClick(item)}>
                    <div className="rcw-home-card-title">
                      {item.title}
                    </div>
                    <div className="rcw-home-card-desc">
                      <span className="intercom-messenger-card-list-item-text-subtitle-secondary-text">
                        {truncateString(item.description, 85)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {!isSessionAvailable && <div className='rcw-home-chat-button'>
                <button onClick={handleStartNewChat} style={{ color: isBgLight ? '#000000' : '#ffffff', background: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor, border: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor === "#ffffff" ? '1px solid #dddddd' : '' }}>Start New Chat</button>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
